import React from "react";
import { withRouter, Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Select from "react-select";
import { TfiLocationPin } from "react-icons/tfi";
import { BsCalendarDate } from "react-icons/bs";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from '@mui/material/Checkbox';
import { BsCircle, BsCheckCircleFill } from "react-icons/bs";
import axios from "axios";
import {Helmet} from "react-helmet";

import top_badge from "../../assets/top_badge.png";
import "./feedback.css";
import Footer from "../../components/Footer/footer";
import "react-toastify/dist/ReactToastify.css";


class feedback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        name: "",
        phone: "",
        training_name: "",
        training_id: 1,
        trainingOptions: [
          { value: "Awareness Workshop", label: "Awareness Workshop" },
          { value: "Digital Literacy", label: "Digital Literacy" },
          { value: "Digital Photography and Scanning", label: "Digital Photography and Scanning" },
          { value: "CAD/CAM Technology", label: "CAD/CAM Technology" },
          { value: "IT based Capacity Building", label: "IT based Capacity Building" },
          { value: "Entrepreneurship & Soft Skills Development", label: "Entrepreneurship & Soft Skills Development" }
        ],
        trainingDatesOptions: [],
        training_date: "",
        errors: {},
        infoView: true,
        checkBox: true,
        checkBox2: true,
        message: "",
        suggestions: ""
    };
    this.handleName = this.handleName.bind(this);
    this.handlePhone = this.handlePhone.bind(this);
    this.checkFirstForm = this.checkFirstForm.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleSuggestions = this.handleSuggestions.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.warnToast = this.warnToast.bind(this);
    this.toastFunct = this.toastFunct.bind(this);
  }
  componentDidMount(){
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    
  }
  handleName(event) {
    let errors = this.state.errors;
    let name = event.target.value.length
    if (name>1) {
      errors["name"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["name"] = "Must not be empty";
      this.setState({ errors: errors});
    }
    this.setState({
      name: event.target.value,
    });
  }
  handlePhone(object) {
    if (object.target.value.length <= object.target.maxLength) {
      this.setState({ phone: object.target.value });
    }
    let errors = this.state.errors;
    var phoneLength = object.target.value.length;
    if (phoneLength === 11 || phoneLength === 10 ) {
      errors["phone"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["phone"] = "Must be 10 digits";
      this.setState({ errors: errors});
    }
  }
  handleTrainingChange = (training_name) => {
    this.setState({ training_name: training_name.value });
    if(training_name.value === "Digital Literacy"){
      this.getTrainingData(1);
      this.setState({
        training_id: 1
      })
    }
    if(training_name.value === "Digital Photography and Scanning"){
      this.getTrainingData(2);
      this.setState({
        training_id: 2
      })
    }
    if(training_name.value === "CAD/CAM Technology"){
      this.getTrainingData(3);
      this.setState({
        training_id: 3
      })
    }
    if(training_name.value === "IT based Capacity Building"){
      this.getTrainingData(4);
      this.setState({
        training_id: 4
      })
    }
    if(training_name.value === "Entrepreneurship & Soft Skills Development"){
      this.getTrainingData(5);
      this.setState({
        training_id: 5
      })
    }
    if(training_name.value === "Awareness Workshop"){
      this.getTrainingData(6);
      this.setState({
        training_id: 6
      })
    }
  };
  getTrainingData = (id) => {
    fetch(`https://dihh.nielitkohima.in/admin/api/get_training_date.php?id=` + id, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((responseJson) => {
        let trainingDatesOptions = []
        if(responseJson){
          responseJson.forEach((obj) => {
            var d = new Date(obj.starting_date);
            let formatedDate = moment(d).format('DD MMMM, YYYY')
            trainingDatesOptions.push(
              {
                value: formatedDate, label: formatedDate
              }
            )
          })
          let reversedArray = trainingDatesOptions.reverse()
          this.setState({
            trainingDatesOptions: reversedArray
          })
        }
      })
      .catch((error) => {
        console.error(error);
        let trainingDatesOptions = [];
        this.setState({
          trainingDatesOptions: trainingDatesOptions,
          training_date: ""
        })

      });
  }
  handleTrainingDateChange = (training_date) => {
    this.setState({ training_date: training_date.value });
  }
  checkFirstForm = () => {
    const {name, phone, training_name, training_date} = this.state;
    let nameWarning = this.state.errors["name"];
    let phoneWarning = this.state.errors["phone"];
    if(name != "" && phone != "" && training_name != "" && training_date != ""){
      if(nameWarning == null && phoneWarning == null)
      {
        this.setState({
          infoView: false
        })
      }
      else{
        this.warnToast();
        console.log("Form Invalid")
      }
    }
    else{
      this.warnToast();
      console.log("Form Invalid")
    }
  };
  warnToast() {
    toast.warn("Form Data Invalid", {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
  toastFunct() {
    toast.info("Sending ..", {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  }
  handleMessage(event) {
    let errors = this.state.errors;
    let message = event.target.value.length
    if (message>14) {
      errors["message"] = null
      this.setState({ errors: errors});
    }
     else {
      errors["message"] = "Must be at least 15 characters";
      this.setState({ errors: errors});
    }
    this.setState({ message: event.target.value });
  }
  handleSuggestions(event) {
    this.setState({ suggestions: event.target.value });
  }
  submitForm = async() => {
    const {message} = this.state;
    let messageWarning = this.state.errors["message"];
    if(message != ""){
      if(messageWarning == null)
      {
        this.toastFunct();
        let apiUrl = "https://dihh.nielitkohima.in/admin/api/add_feedback.php";
        let formData = new FormData();
        formData.append("name", this.state.name);
        formData.append("email_phone",  this.state.phone);
        formData.append("training_id",  this.state.training_id);
        formData.append("training_date",  this.state.training_date);
        formData.append("question_one",  this.state.checkBox ? "Yes" : "No");
        formData.append("question_two",  this.state.checkBox2 ? "Yes" : "No");
        formData.append("question_three",  this.state.message);
        formData.append("suggestion",  this.state.suggestions);
        await axios({
          method: "post",
          url: apiUrl,
          data: formData,
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .then((response) => {
          console.log(response);
          if (response.data.Status === "TRUE! Feedback Added Successfully") {
            toast.success('Feedback Submitted', {
              position: "bottom-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setTimeout(() => {
              window.location.reload()
            }, 1000);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      }
      else{
        this.warnToast();
        console.log("Form Invalid")
      }
    }
    else{
      this.warnToast();
      console.log("Form Invalid")
    }
  };
  render() {
    const { training_name, trainingOptions, trainingDatesOptions, training_date, checkBox, checkBox2 } = this.state;
    return (
      <div>
        <Helmet>
          <html lang="en" />  
          <meta charSet="utf-8" />
          <title>NIELIT Kohima - Digital Intervention of Handloom and Handicraft | Feedback</title>
          <meta name="description" content="The project 'Digital Intervention of Handicraft & Handloom' was commenced in the year 2021. Trainings for each of the sector are organised on monthly basis, which empowers the handicraft and handloom in the state of Nagaland as a pilot project initiated by the Ministry of Electronics and Information Technology, Govt. of India." />
          <link rel="canonical" href="https://nielitdihh.in/" />
        </Helmet>
        <div className="feedback_container">
            <Row>
              <Col md={6} xs={12} sm={12}>
                <div className="feedback_container_inner_left">
                    <p className="feedback_header_txt">Feedback</p>
                    <p className="feedback_header_subtxt">Make sure you select the correct training/workshop and the starting date mentioned.</p>
                    {
                      this.state.infoView ?
                        <div className="feedback_container_inner_left_margins">
                          <p className="feedback_form_inputHeaders">Full Name</p>
                          <input
                              className="feedback_name_input"
                              type="text"
                              enterKeyHint="next"
                              value={this.state.name}
                              onChange={this.handleName}
                              onFocus={this.handleName}
                          />
                          {
                              this.state.errors["name"] ? (
                              <p id="marginInputs" className="loginErrorTxt_feedbacks">
                                  {this.state.errors["name"]}
                              </p>
                              ) : (
                              <div className="emptyErrorMargins_feedbacks"></div>
                              )
                          }
                          <p className="feedback_form_inputHeaders">Phone Number</p>
                          <input
                              className="feedback_name_input"
                              onChange={this.handlePhone}
                              onFocus={this.handlePhone}
                              value={this.state.phone}
                              type = "number" maxLength = "10"
                          />
                          {
                              this.state.errors["phone"] ? (
                              <p id="marginInputs" className="loginErrorTxt_feedbacks">
                                  {this.state.errors["phone"]}
                              </p>
                              ) : (
                              <div className="emptyErrorMargins_feedbacks"></div>
                              )
                          }
                          <p className="feedback_form_inputHeaders">Training</p>
                          <Select
                              onChange={this.handleTrainingChange}
                              value={trainingOptions.find(
                                  (item) => item.value === training_name
                              )}
                              options={trainingOptions}
                              placeholder={<div>Select</div>}
                              isSearchable={false}
                              styles={{
                                  control: (provided, state) => ({
                                      ...provided,
                                      height: 48,
                                      borderRadius: 8,
                                      color: "black",
                                      paddingLeft: 5,
                                      borderWidth: 0.5,
                                      borderColor: "#a8a8a8",
                                      marginBottom: "4.5%"
                                  })
                              }}
                          />
                          <p className="feedback_form_inputHeaders">Starting Date</p>
                          <Select
                              onChange={this.handleTrainingDateChange}
                              value={trainingDatesOptions.find(
                                  (item) => item.value === training_date
                              )}
                              options={trainingDatesOptions}
                              placeholder={<div>Select</div>}
                              isSearchable={false}
                              styles={{
                                  control: (provided, state) => ({
                                      ...provided,
                                      height: 48,
                                      borderRadius: 8,
                                      color: "black",
                                      paddingLeft: 5,
                                      borderWidth: 0.5,
                                      borderColor: "#a8a8a8"
                                  })
                              }}
                          />
                          <center>
                            <br/>
                            <button className="requestQuote" onClick={this.checkFirstForm}>
                              Next
                            </button>
                          </center>
                        </div>
                      :
                        <div className="feedback_container_inner_left_margins">
                          <p className="feedback_form2_inputHeaders">Did the training program enhance your knowledge?</p>
                          <Row style={{marginTop: 7, marginBottom:"4.5%"}}>
                            <Col md={3} xs={5} sm={5}>
                                <>
                                    <Checkbox
                                        checked={checkBox}
                                        onChange={() => this.setState({checkBox: !this.state.checkBox})}
                                        icon={<BsCircle size={20} className="chbk-icons"/>}
                                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                                    />
                                    <span className="newDemo-radio-txt">Yes</span>
                                </>
                            </Col>
                            <Col md={3} xs={5} sm={5}>
                                <>
                                    <Checkbox
                                        checked={!checkBox}
                                        onChange={() => this.setState({checkBox: !this.state.checkBox})}
                                        icon={<BsCircle size={20} className="chbk-icons"/>}
                                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                                    />
                                    <span className="newDemo-radio-txt">No</span>
                                </>
                            </Col>
                          </Row>
                          <p className="feedback_form2_inputHeaders">Will you like to attend an advanced training program?</p>
                          <Row style={{marginTop: 7, marginBottom:"4.5%"}}>
                            <Col md={3} xs={5} sm={5}>
                                <>
                                    <Checkbox
                                        checked={checkBox2}
                                        onChange={() => this.setState({checkBox2: !this.state.checkBox2})}
                                        icon={<BsCircle size={20} className="chbk-icons"/>}
                                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                                    />
                                    <span className="newDemo-radio-txt">Yes</span>
                                </>
                            </Col>
                            <Col md={3} xs={5} sm={5}>
                                <>
                                    <Checkbox
                                        checked={!checkBox2}
                                        onChange={() => this.setState({checkBox2: !this.state.checkBox2})}
                                        icon={<BsCircle size={20} className="chbk-icons"/>}
                                        checkedIcon={<BsCheckCircleFill size={20} className="chbk-icons"/>}
                                    />
                                    <span className="newDemo-radio-txt">No</span>
                                </>
                            </Col>
                          </Row>
                          <p className="feedback_form2_inputHeaders">What was the most beneficial learning outcome of the training?</p>
                          <textarea
                            className="messageInput_feedback"
                            type="text"
                            placeholder="Write how the training learnings will help you"
                            rows="4"
                            value={this.state.message}
                            onFocus={this.handleMessage}
                            onChange={this.handleMessage}
                          />
                          {
                              this.state.errors["message"] ? (
                              <p id="marginInputs" className="loginErrorTxt_feedbacks">
                                  {this.state.errors["message"]}
                              </p>
                              ) : (
                              <div className="emptyErrorMargins_feedbacks"></div>
                              )
                          }
                          <p className="feedback_form2_inputHeaders">Any suggestions?</p>
                          <textarea
                            className="messageInput_feedback"
                            type="text"
                            placeholder="Optional"
                            rows="4"
                            value={this.state.suggestions}
                            onFocus={this.handleSuggestions}
                            onChange={this.handleSuggestions}
                          />
                          <center>
                            <br/>
                            <button className="requestQuote" onClick={this.submitForm}>
                              Submit
                            </button>
                          </center>
                        </div>
                    }
                </div>
              </Col>
              <Col md={1}></Col>
              <Col md={5} xs={12} sm={12}>
                <div className="home-content-body_right feedback_recentEvents_margin">
                  <img src={top_badge} className="home-content-body_right_img"/>
                  <br clear="all" />
                  <div className="home-content-body_right_inner">
                    <div>
                      <p className="home-content-body_right_inner_header">Handicraft Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={4} sm={4} style={{marginTop: 1}}>
                          <span>Dimapur</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>2nd March, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Weaving Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={11} sm={11} style={{marginTop: 1}}>
                          <span>Kohima</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>24th Feb, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Digital Literacy Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={4} sm={4} style={{marginTop: 1}}>
                          <span>Kohima</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>10th Feb, 2025</span>
                        </Col>
                      </Row>
                      <hr/>
                      <p className="home-content-body_right_inner_header">Weaving Training</p>
                      <Row>
                        <Col md={1} xs={1} sm={1}>
                          <TfiLocationPin
                            size={22}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 1}}>
                          <span>Dimapur</span>
                        </Col>
                      </Row>
                      <Row style={{marginTop: 5}}>
                        <Col md={1} xs={1} sm={1}>
                          <BsCalendarDate
                            size={20}
                          />
                        </Col>
                        <Col xs={7} sm={7} style={{marginTop: 2}}>
                          <span>3rd Feb, 2025</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <ToastContainer
              position="bottom-center"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
        </div>
        <Footer/>
      </div>
    )
  }
}
export default withRouter(feedback);